const buttonThemes = {
	'SECONDARY'     : 'secondary',
	'ACTION'        : 'action',
	'LIGHT_INVERSE' : 'light_inverse',
	'TEXT'					: 'text',
};

export default buttonThemes;


// WEBPACK FOOTER //
// ./src/ui/button/buttonThemes.js